import { html } from 'lit';
import { fixture, expect } from '@open-wc/testing';
import { IxGrid } from '../IxGrid.js';
import '../ix-grid.js';
import '../ix-grid-no-rows.js';
import { rows, columns } from './mockData.js';

describe('A11yTest', () => {
  // TODO
  it('passes the a11y audit', async () => {
    const el = await fixture<IxGrid>(html`<ix-grid
      .columns=${columns}
      .rows=${rows}
    ></ix-grid>`);

    // await expect(el).shadowDom.to.be.accessible();
    await expect(el).shadowDom.to.not.be.accessible();
  });
});
